import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import Breadcrumbs from "../components/Breadcrumbs"; // ✅ Import Breadcrumbs

function Terms() {
  return (
    <>
      {/* Breadcrumbs */}
      <div className="px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <Breadcrumbs current="Terms of Agreement" />
        </div>
      </div>

      {/* Hero Section */}
      <div className="bg-gray-100 py-12 mb-10 px-4 md:px-6">
        <div className="max-w-6xl mx-auto text-center">
          <h1 className="text-4xl font-bold text-blue-700 mb-2">Terms of Agreement</h1>
          <p className="text-gray-600 text-sm">
            By using our service, you agree to the following terms and conditions governing your experience with Exudee Hampers.
          </p>
        </div>
      </div>

      {/* Page Content */}
      <div className="max-w-6xl mx-auto px-4 pb-12">
        <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">1. Agreement</h2>
            <p className="text-gray-700 text-sm leading-relaxed">
              By using Exudee Hampers services, including the mobile application and website, you agree to be
              bound by these Terms of Service ("Terms"). If you do not agree to these Terms, do not use our
              services.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">2. Service Description</h2>
            <p className="text-gray-700 text-sm leading-relaxed">
              Exudee Hampers provides a flower and accessory hamper delivery service within Dallas, Texas, and a
              51-mile radius. We offer standard hampers and VIP or designer packages, which may include flowers
              and accessories.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">3. Ordering and Delivery</h2>
            <ul className="list-disc pl-5 text-gray-700 text-sm leading-relaxed space-y-2">
              <li><span className="font-medium">Order Placement:</span> Orders must be placed through our mobile application or website.</li>
              <li><span className="font-medium">Order Acceptance:</span> All orders are subject to acceptance by Exudee Hampers. We reserve the right to refuse any order.</li>
              <li><span className="font-medium">Delivery Time:</span> We aim to deliver orders within 3 to 5 hours after placement, for orders placed before 3:00 PM CST.</li>
              <li><span className="font-medium">Same-Day Delivery After 3:00 PM:</span> Orders placed after 3:00 PM CST will be delivered the following day unless a $50.00 fee is paid for same-day delivery.</li>
              <li><span className="font-medium">Delivery Area:</span> We only deliver within Dallas, Texas, and a 51-mile radius. Our system may not allow orders outside this radius.</li>
              <li><span className="font-medium">Free Delivery:</span> Free delivery is included within our delivery area, except for the $50.00 instant delivery fee after 3:00 PM CST.</li>
              <li><span className="font-medium">Delivery Issues:</span> If issues arise (e.g., damaged or incorrect items), you must notify us within 24 hours of receipt. A replacement or refund may be offered after review.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">4. Products and Pricing</h2>
            <ul className="list-disc pl-5 text-gray-700 text-sm leading-relaxed space-y-2">
              <li><span className="font-medium">Product Availability:</span> All products are subject to availability. We reserve the right to substitute items of equal or greater value if necessary.</li>
              <li><span className="font-medium">Pricing:</span> Prices are as listed on our mobile application or website and are subject to change without notice.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">5. Payment</h2>
            <ul className="list-disc pl-5 text-gray-700 text-sm leading-relaxed space-y-2">
              <li><span className="font-medium">Payment Methods:</span> We accept payment through the methods specified on our mobile application or website.</li>
              <li><span className="font-medium">Payment Authorization:</span> By placing an order, you authorize us to charge your selected payment method for the total amount, including applicable taxes and fees.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">6. Cancellations and Refunds</h2>
            <ul className="list-disc pl-5 text-gray-700 text-sm leading-relaxed space-y-2">
              <li><span className="font-medium">Cancellation Policy:</span> Orders may be canceled up to 30 minutes before the scheduled delivery time. Cancellations made after this time may not be eligible for a refund.</li>
              <li><span className="font-medium">Refund Policy:</span> Refunds are processed at our discretion, considering the reason for the refund and the condition of delivered items.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">7. Customer Conduct</h2>
            <p className="text-gray-700 text-sm leading-relaxed">
              You agree to use our services in compliance with all applicable laws. You must not use our services
              for unlawful purposes, interfere with the operation of our platform, or provide false/misleading information.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">8. Intellectual Property</h2>
            <p className="text-gray-700 text-sm leading-relaxed">
              All the content on our mobile application and website — including text, graphics, logos, and images — is our
              property or the property of our licensors, protected by copyright laws.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">9. Limitation of Liability</h2>
            <p className="text-gray-700 text-sm leading-relaxed">
              To the fullest extent permitted by law, Exudee Hampers shall not be liable for any indirect,
              incidental, special, consequential, or punitive damages related to your use of our services.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">10. Disclaimer of Warranties</h2>
            <p className="text-gray-700 text-sm leading-relaxed">
              Our services are provided on an "as is" and "as available" basis. We make no warranties, express
              or implied, including warranties of merchantability, fitness for a particular purpose, or
              non-infringement.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">11. Indemnification</h2>
            <p className="text-gray-700 text-sm leading-relaxed">
              You agree to indemnify and hold Exudee Hampers harmless from any claims, damages, or expenses
              arising from your use of our services or your violation of these terms.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">12. Governing Law</h2>
            <p className="text-gray-700 text-sm leading-relaxed">
              These Terms shall be governed by and construed in accordance with the laws of the State of Texas,
              without regard to conflict of law principles.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">13. Dispute Resolution</h2>
            <p className="text-gray-700 text-sm leading-relaxed">
              Any disputes arising from these Terms shall be resolved through mediation, arbitration, or small
              claims court in Dallas County, Texas.
            </p>
          </section>

        {/* Back to Home Link */}
        <div className="text-center">
          <Link
            to="/"
            className="inline-flex items-center text-blue-600 hover:underline text-sm font-medium"
          >
            ← Back to Home
          </Link>
        </div>
      </div>

      {/* Footer */}
      <div data-aos="fade-up">
        <Footer />
      </div>
    </>
  );
}

export default Terms;
